import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { AccountSelection } from './components/AccountSelection';
import { NameConfirmation } from './components/NameConfirmation';
import { AddressConfirmation } from './components/AddressConfirmation';
import { AddressVerificationDrawer } from './components/AddressVerificationDrawer';
import { AllProducts } from './components/AllProducts';
import { ProductCategory } from './components/ProductCategory';
import { ProductDetailsDrawer } from './components/ProductDetailsDrawer';
import { ShoppingCartDrawer } from './components/ShoppingCartDrawer';
import { CartConfirmation } from './components/CartConfirmation';
import { ApplicationPreparation } from './components/ApplicationPreparation';
import { PhoneVerification } from './components/PhoneVerification';
import { VerificationCodeModal } from './components/VerificationCodeModal';
import { PhoneVerificationConfirmation } from './components/PhoneVerificationConfirmation';
import { IdentityDocumentsPrep } from './components/IdentityDocumentsPrep';
import { IdScanFront } from './components/IdScanFront';
import { IdScanBack } from './components/IdScanBack';
import { SelfieCapture } from './components/SelfieCapture';
import { VerificationComplete } from './components/VerificationComplete';
import { HomeScreen } from './components/HomeScreen';
import { Lobby } from './components/Lobby';
import { productData } from './data/productData';
export function App() {
  const [showHomeScreen, setShowHomeScreen] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [showAllProducts, setShowAllProducts] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState({
    checking: true,
    savings: false
  });
  // Track selected products for cart
  const [cartItems, setCartItems] = useState([]);
  const [userData, setUserData] = useState({
    firstName: 'Mary',
    lastName: 'Schofield',
    phoneNumber: '',
    address: '999 Mitchel Ave',
    city: 'Lansing',
    state: 'MI',
    zip: '48917'
  });
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductDetails, setShowProductDetails] = useState(false);
  const [showCartDrawer, setShowCartDrawer] = useState(false);
  const [showCartConfirmation, setShowCartConfirmation] = useState(false);
  const [showApplicationPrep, setShowApplicationPrep] = useState(false);
  const [showPhoneVerification, setShowPhoneVerification] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showPhoneConfirmation, setShowPhoneConfirmation] = useState(false);
  const [showIdentityPrep, setShowIdentityPrep] = useState(false);
  const [showIdScanFront, setShowIdScanFront] = useState(false);
  const [showIdScanBack, setShowIdScanBack] = useState(false);
  const [showSelfieCapture, setShowSelfieCapture] = useState(false);
  const [showVerificationComplete, setShowVerificationComplete] = useState(false);
  const [showAddressVerificationDrawer, setShowAddressVerificationDrawer] = useState(false);
  const [isResuming, setIsResuming] = useState(false);
  const [showLobby, setShowLobby] = useState(false);
  // Listen for add-to-cart events
  useEffect(() => {
    const handleAddToCart = event => {
      const {
        type,
        product
      } = event.detail;
      // Add product to cart items
      setCartItems(prev => {
        // Check if product already exists
        const exists = prev.some(item => item.name === product.name && item.type === type);
        if (exists) return prev;
        return [...prev, {
          ...product,
          type
        }];
      });
      // Also update selectedProducts for compatibility
      setSelectedProducts(prev => ({
        ...prev,
        [type]: true
      }));
    };
    window.addEventListener('add-to-cart', handleAddToCart);
    return () => window.removeEventListener('add-to-cart', handleAddToCart);
  }, []);
  const handleProductSelect = product => {
    setSelectedProducts(prev => ({
      ...prev,
      [product]: !prev[product]
    }));
  };
  const handleRemoveProduct = product => {
    // Remove from cartItems
    if (typeof product === 'object') {
      setCartItems(prev => prev.filter(item => item.name !== product.name));
    } else {
      // Legacy support for removing by type
      setSelectedProducts(prev => ({
        ...prev,
        [product]: false
      }));
      // Also remove from cartItems
      setCartItems(prev => prev.filter(item => item.type !== product));
    }
  };
  const handleContinue = () => {
    // Show cart confirmation instead of going directly to step 2
    setShowCartConfirmation(true);
  };
  const handleContinueToPrep = () => {
    setShowCartConfirmation(false);
    setShowApplicationPrep(true);
  };
  const handleContinueToPhoneVerification = () => {
    setShowApplicationPrep(false);
    setShowPhoneVerification(true);
  };
  const handleSubmitPhoneNumber = phoneNumber => {
    setUserData(prev => ({
      ...prev,
      phoneNumber
    }));
    setShowVerificationModal(true);
  };
  const handleVerifyPhoneNumber = () => {
    setShowVerificationModal(false);
    setShowPhoneVerification(false);
    if (isResuming) {
      // If resuming, show the Lobby component instead of going to step 2
      setIsResuming(false);
      setShowLobby(true);
    } else {
      setShowPhoneConfirmation(true);
    }
  };
  const handlePhoneConfirmationNext = () => {
    setShowPhoneConfirmation(false);
    setShowIdentityPrep(true);
  };
  const handleIdentityPrepNext = () => {
    setShowIdentityPrep(false);
    setShowIdScanFront(true);
  };
  const handleIdScanFrontNext = () => {
    setShowIdScanFront(false);
    setShowIdScanBack(true);
  };
  const handleIdScanBackNext = () => {
    setShowIdScanBack(false);
    setShowSelfieCapture(true);
  };
  const handleSelfieCaptureNext = () => {
    setShowSelfieCapture(false);
    setShowVerificationComplete(true);
  };
  const handleVerificationCompleteNext = () => {
    setShowVerificationComplete(false);
    setCurrentStep(2);
  };
  const handleNameConfirmationNext = () => {
    setCurrentStep(3);
  };
  const handleAddressConfirmation = () => {
    setShowAddressVerificationDrawer(true);
  };
  const handleAddressVerificationConfirm = () => {
    setShowAddressVerificationDrawer(false);
    setCurrentStep(4);
  };
  const handleBack = () => {
    if (showProductDetails) {
      setShowProductDetails(false);
      return;
    }
    if (selectedCategory) {
      setSelectedCategory(null);
      return;
    }
    if (showAllProducts) {
      setShowAllProducts(false);
      return;
    }
    if (currentStep === 4) {
      setCurrentStep(3);
      return;
    }
    if (currentStep === 3) {
      setCurrentStep(2);
      return;
    }
    if (currentStep === 2) {
      setCurrentStep(1);
      setShowVerificationComplete(true);
      return;
    }
    if (showVerificationComplete) {
      setShowVerificationComplete(false);
      setShowSelfieCapture(true);
      return;
    }
    if (showSelfieCapture) {
      setShowSelfieCapture(false);
      setShowIdScanBack(true);
      return;
    }
    if (showIdScanBack) {
      setShowIdScanBack(false);
      setShowIdScanFront(true);
      return;
    }
    if (showIdScanFront) {
      setShowIdScanFront(false);
      setShowIdentityPrep(true);
      return;
    }
    if (showIdentityPrep) {
      setShowIdentityPrep(false);
      setShowPhoneConfirmation(true);
      return;
    }
    if (showPhoneConfirmation) {
      setShowPhoneConfirmation(false);
      setShowPhoneVerification(true);
      return;
    }
    if (showPhoneVerification) {
      if (isResuming) {
        setShowPhoneVerification(false);
        setIsResuming(false);
        setShowHomeScreen(true);
      } else {
        setShowPhoneVerification(false);
        setShowApplicationPrep(true);
      }
      return;
    }
    if (showApplicationPrep) {
      setShowApplicationPrep(false);
      setShowCartConfirmation(true);
      return;
    }
    if (showCartConfirmation) {
      setShowCartConfirmation(false);
      return;
    }
    setShowHomeScreen(true);
  };
  const handleUserDataChange = (field, value) => {
    setUserData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleSeeAllProducts = () => {
    setShowAllProducts(true);
  };
  const handleCategorySelect = category => {
    setSelectedCategory(category);
  };
  const handleProductDetails = product => {
    setSelectedProduct(product);
    setShowProductDetails(true);
  };
  const handleCloseProductDetails = () => {
    setShowProductDetails(false);
  };
  const handleToggleCart = () => {
    setShowCartDrawer(prev => !prev);
  };
  const handleGetStarted = () => {
    setShowHomeScreen(false);
  };
  const handleResumeApplication = () => {
    setShowHomeScreen(false);
    setIsResuming(true);
    setShowPhoneVerification(true);
  };
  const handleHomeClick = () => {
    // Reset all states to go back to home
    setShowHomeScreen(true);
    setCurrentStep(1);
    setShowAllProducts(false);
    setSelectedCategory(null);
    setShowProductDetails(false);
    setShowCartDrawer(false);
    setShowCartConfirmation(false);
    setShowApplicationPrep(false);
    setShowPhoneVerification(false);
    setShowVerificationModal(false);
    setShowPhoneConfirmation(false);
    setShowIdentityPrep(false);
    setShowIdScanFront(false);
    setShowIdScanBack(false);
    setShowSelfieCapture(false);
    setShowVerificationComplete(false);
    setShowAddressVerificationDrawer(false);
    setIsResuming(false);
    setShowLobby(false);
  };
  return <div className="flex flex-col w-full min-h-screen bg-white relative" data-id="element-0">
      {!showHomeScreen && !showLobby && <Header onCartClick={handleToggleCart} onHomeClick={handleHomeClick} data-id="element-1" />}
      {showHomeScreen ? <HomeScreen onGetStarted={handleGetStarted} onResumeApplication={handleResumeApplication} data-id="element-2" /> : showLobby ? <Lobby data-id="element-3" /> : <>
          {currentStep === 1 && !showAllProducts && !selectedCategory && !showCartConfirmation && !showApplicationPrep && !showPhoneVerification && !showPhoneConfirmation && !showIdentityPrep && !showIdScanFront && !showIdScanBack && !showSelfieCapture && !showVerificationComplete && <AccountSelection selectedProducts={selectedProducts} onProductSelect={handleProductSelect} onContinue={handleContinue} onSeeAllProducts={handleSeeAllProducts} data-id="element-4" />}
          {showCartConfirmation && <CartConfirmation selectedProducts={selectedProducts} productData={productData} cartItems={cartItems} onBack={handleBack} onContinue={handleContinueToPrep} data-id="element-5" />}
          {showApplicationPrep && <ApplicationPreparation onBack={handleBack} onNext={handleContinueToPhoneVerification} data-id="element-6" />}
          {showPhoneVerification && <PhoneVerification onBack={handleBack} onSubmit={handleSubmitPhoneNumber} isResuming={isResuming} data-id="element-7" />}
          {showVerificationModal && <VerificationCodeModal onClose={() => setShowVerificationModal(false)} onVerify={handleVerifyPhoneNumber} data-id="element-8" />}
          {showPhoneConfirmation && <PhoneVerificationConfirmation onBack={handleBack} onNext={handlePhoneConfirmationNext} data-id="element-9" />}
          {showIdentityPrep && <IdentityDocumentsPrep onBack={handleBack} onNext={handleIdentityPrepNext} data-id="element-10" />}
          {showIdScanFront && <IdScanFront onBack={handleBack} onNext={handleIdScanFrontNext} data-id="element-11" />}
          {showIdScanBack && <IdScanBack onBack={handleBack} onNext={handleIdScanBackNext} data-id="element-12" />}
          {showSelfieCapture && <SelfieCapture onBack={handleBack} onNext={handleSelfieCaptureNext} data-id="element-13" />}
          {showVerificationComplete && <VerificationComplete onBack={handleBack} onNext={handleVerificationCompleteNext} data-id="element-14" />}
          {currentStep === 2 && <NameConfirmation userData={userData} onUserDataChange={handleUserDataChange} onBack={handleBack} onNext={handleNameConfirmationNext} data-id="element-15" />}
          {currentStep === 3 && <AddressConfirmation userData={userData} onUserDataChange={handleUserDataChange} onBack={handleBack} onConfirm={handleAddressConfirmation} data-id="element-16" />}
          {showAllProducts && !selectedCategory && <AllProducts onCategorySelect={handleCategorySelect} onBack={handleBack} data-id="element-17" />}
          {selectedCategory && <ProductCategory category={selectedCategory} products={productData[selectedCategory]} onBack={handleBack} onProductDetails={handleProductDetails} data-id="element-18" />}
          {showProductDetails && selectedProduct && <ProductDetailsDrawer product={selectedProduct} onClose={handleCloseProductDetails} data-id="element-19" />}
          <ShoppingCartDrawer isOpen={showCartDrawer} onClose={handleToggleCart} selectedProducts={selectedProducts} productData={productData} cartItems={cartItems} onRemoveProduct={handleRemoveProduct} data-id="element-20" />
          <AddressVerificationDrawer isOpen={showAddressVerificationDrawer} onClose={() => setShowAddressVerificationDrawer(false)} userData={userData} onConfirm={handleAddressVerificationConfirm} data-id="element-21" />
        </>}
    </div>;
}